import React, { MouseEvent } from "react";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import Modal from "../../../../components/common/form/Modal";
import { formatValueAsDateAndTime } from "../../../../helpers/utils/DateUtils";
import { getEnumDisplayNameByConstant } from "../../../../helpers/utils/EnumUtils";
import InputField from "../../../../components/common/form/InputField";
import Button from "../../../../components/common/form/Button";

// Define prop types
interface FnfTransactionInfoModalProps {
    show: boolean;
    setShow: (value: boolean) => void;
    customerOrderNumber?: any;
    productType?: any;
    creationDate?: any;
    amount?: any;
    reason?: any;
}

const FnfTransactionInfoModal: React.FC<FnfTransactionInfoModalProps> = ({
    show,
    setShow,
    customerOrderNumber,
    productType,
    creationDate,
    amount,
    reason
}) => {

    const ProductTypeEnum = useGetEnumsQuery("");
    function dismissModal(e: MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        setShow(false);
    }

    function applyFallback(val: string | null): string {
        return val === null || val === "" ? "-" : val;
    }

    return (
        <Modal
            title={"Fnf Transaction Info"}
            show={show}
            setShow={setShow}
            className={"w-2/6 bg-text-0 text-surface-0"}
            fields={
                <>

                    <div className="modal-body">
                        <InputField
                            className="form-control"
                            value={customerOrderNumber}
                            type="text"
                            disabled
                            label="Ref. No."
                        />
                        <InputField
                            className="form-control"
                            value={getEnumDisplayNameByConstant(ProductTypeEnum, productType)}
                            type="text"
                            disabled
                            label="Product Type"
                        />
                        <InputField
                            className="form-control"
                            value={applyFallback(formatValueAsDateAndTime(String(creationDate)))}
                            type="text"
                            disabled
                            label="Creation Date"
                        />
                        <InputField
                            className="form-control"
                            value={amount}
                            type="text"
                            disabled
                            label="Amount"
                        />

                        <InputField
                            className="form-control"
                            value={reason}
                            type="text"
                            disabled
                            label="Reason"
                        />
                    </div>

                    <div className="mt-4 border-t border-t-surface-5 flex justify-end pt-3">
                        <Button btnText="Close" type="close" onClick={dismissModal} />


                    </div>
                </>
            }
        />
    );
};

export default FnfTransactionInfoModal;
